export default function NoMatch() {
    return (
        <div className="d-flex flex-column align-items-center">
            <img
                alt="404 not Found"
                src="/404.svg"
                className="not-found-img"

            />
            <h5
                                className="not-found-text"
            >
                This Page doesn`t exist or was removed!
                <br /> We suggest you go back to the homepage.
            </h5>
            <a
                href="/app/dashboard"
                className="return-home-btn"
                aria-label="Go to food logging"
            >
                Return To Homepage
            </a>
        </div>
    );
}
